import { fetchDataFromBackend } from "../api/api";
import {
    WeekPlanEmployeeDTO,
    CalendarEmployeeDTO,
    DailyPlanEmployeeDTO,
    WorkDurationEmployeeDTO
  } from "../DTOs/weekPlanEmployeeDTO";
import logger from "../core/utils/logger";

const isSimulation = import.meta.env.VITE_BACKEND_DATA_SIMULATION === "true";

// Helper: Generate properly structured DTO-based week plan data
const generateSimulatedWeekPlanData = (week, year, count = 100) => {
    const daysOfWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday","Saturday", "Sunday"];
  
    return Array.from({ length: count }).map((_, index) => {
      const userId = `user-${index + 1}`;
      const userName = `User ${index + 1}`;
  
      const calendarEmployee = new CalendarEmployeeDTO({
        id: index + 1000,
        year,
        weekCalendarNumber: week,
        activate: true,
        workTimeHours: 40,
        workTimeMinutes: 0,
        dailyPlanEmployees: daysOfWeek.map((dayName, i) => {
          const workDuration = new WorkDurationEmployeeDTO({
            id: `${userId}-wd-${dayName}`,
            startTime: new Date(year, 0, 1 + (week - 1) * 7 + i, 9, 0),
            endTime: new Date(year, 0, 1 + (week - 1) * 7 + i, 17, 0),
          });

          // Assign a random dayStatus for more realistic test data (0-9)
          const randomDayStatus = Math.floor(Math.random() * 9);

          return new DailyPlanEmployeeDTO({
            id: `${userId}-day-${dayName}`,
            day: dayName, // Use day name string here
            dayStatus: randomDayStatus,
            comment: `Planned work for ${dayName}`,
            workDurationEmployees: [workDuration]
          });
        })
      });
  
      return new WeekPlanEmployeeDTO({
        id: index + 1,
        organizationId: `org-${(index % 5) + 1}`,
        userId,
        userName,
        calendarEmployees: [calendarEmployee]
      });
    });
};


export const WeekPlanService = {
    async getUserWeekPlan(week, year, viewerMode = false) {
        try {
            if (isSimulation) {


                logger.log(`Simulation mode: generating week plan for week ${week}, year ${year}`);
                const simulated = generateSimulatedWeekPlanData(week, year, 100); // Generate 100 users
                logger.log("Simulated DTO:", JSON.stringify(simulated[0], null, 2));
                return simulated;
            }
            const response = await fetchDataFromBackend(`/WeekPlanEmployee/GetWeekPlanEmployeeByOrgIdInWeekAndYear?week=${week}&year=${year}&viewerMode=${viewerMode}`, {skipAuth: false, method: 'get'});
            logger.log("User week plan response:", JSON.stringify(response));
            var result = response.map(item=>new WeekPlanEmployeeDTO(item));
            logger.log("User week plan Result:", JSON.stringify(result,null,2));
            return result;
        } catch (error) {
            logger.error("Error getting user week plan:", error);
            throw error;
        }
    },
    async saveUserWeekPlan(userWeekPlan, week, year) {
        try {
            logger.log("User week plan:", JSON.stringify(userWeekPlan));
            if (isSimulation) {
                logger.log(`Simulation mode: skipping backend save for week ${week}, year ${year}`);
                return { success: true, message: "Simulated save successful" };
            }
            
            const response = await fetchDataFromBackend(`/WeekPlanEmployee/InsertWeekPlanEmployee?week=${week}&year=${year}`, {skipAuth: false, method: 'post', data: userWeekPlan});
            return response;
        } catch (error) {
            logger.error("Error saving user week plan:", error);
            throw error;
        }
    },
    async getUserMonthPlan(month, year) {
        try {
            logger.log("🚀 getUserMonthPlan CALLED");

            if (isSimulation) {
                logger.log(`Simulation mode: generating month plan for month ${month}, year ${year}`);
                const simulated = generateSimulatedMonthPlanData(month, year, 100);
                logger.log("✅ First Simulated Month Record:", JSON.stringify(simulated[0], null, 2));
                return simulated;
            }

            const response = await fetchDataFromBackend(`/WeekPlanEmployee/GetMonthPlanEmployeeByOrgIdInMonthAndYear?month=${month}&year=${year}`, { skipAuth: false, method: 'get' });
            logger.log("User month plan response:", JSON.stringify(response));
            return response;
        } catch (error) {
            logger.error("Error getting user month plan:", error);
            throw error;
        }
    },
    async deleteUserWeekPlan(userId, week, year) {
        try {
            if (isSimulation) {
                logger.log(`Simulation mode: skipping delete for user ${userId}, week ${week}, year ${year}`);
                return { success: true, message: "Simulated delete successful" };
            }
            const response = await fetchDataFromBackend(`/WeekPlanEmployee/DeleteWeekPlanEmployee/user/${userId}/year/${year}/week/${week}`, {
                skipAuth: false,
                method: 'delete'
                
              });
            return response;
        } catch (error) {
            logger.error("Error deleting user week plan:", error);
            throw error;
        }
    }
};